var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9933 5.09333V0H2.21333C0.99 0 0 0.99 0 2.21333V17.7833C0 19.01 0.99 20 2.21333 20H17.7833C19.0067 20 19.9967 19.01 19.9967 17.7867V6.00667H14.9067C14.4033 6.00667 13.9933 5.59667 13.9933 5.09333ZM12.1133 16.2667C12.1133 16.82 11.6667 17.2667 11.1133 17.2667H3.69C3.13667 17.2667 2.69 16.82 2.69 16.2667V16.1367C2.69 15.5833 3.13667 15.1367 3.69 15.1367H11.1133C11.6667 15.1367 12.1133 15.5833 12.1133 16.1367V16.2667ZM12.1133 12.7933C12.1133 13.3467 11.6667 13.7933 11.1133 13.7933H3.69C3.13667 13.7933 2.69 13.3467 2.69 12.7933V12.6633C2.69 12.11 3.13667 11.6633 3.69 11.6633H11.1133C11.6667 11.6633 12.1133 12.11 12.1133 12.6633V12.7933ZM12.1133 9.32C12.1133 9.87333 11.6667 10.32 11.1133 10.32H3.69C3.13667 10.32 2.69 9.87333 2.69 9.32V9.19C2.69 8.63667 3.13667 8.19 3.69 8.19H11.1133C11.6667 8.19 12.1133 8.63667 12.1133 9.19V9.32ZM15.1967 3.88V0L20 4.80333H16.12C15.61 4.80333 15.1967 4.39 15.1967 3.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.c9f5ab441498ea8d9b6048950890f92b.svg";
export { ForwardRef as ReactComponent };